export default __webpack_public_path__ + "static/media/logo.f487ff28.png";